import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

import { ReadonlyDisplayBase } from './readonly-display.base';
import { ValueDisplayComponent } from './value-display.component';
import { VerifiedValueComponent } from './verified-value.component';
import { isKvkVerified } from '../verification.util';

/**
 * Read display for a `kvk` answer: the same text as before, plus the check `kvk.component.ts`
 * shows once the number was looked up and confirmed (verification.util.ts). No lookup, no icon.
 *
 * Presentational: both inputs come from the row.
 *
 * The icon and its layout live in `VerifiedValueComponent`; this component only decides `verified`.
 */
@Component({
  selector: 'dd-kvk-display',
  imports: [ValueDisplayComponent, VerifiedValueComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // display: contents — same reason as ValueDisplayComponent: no box inside the value span.
  styles: `
    :host {
      display: contents;
    }
  `,
  template: `
    <dd-verified-value
      [verified]="verified()"
      icon="check_circle"
      label="Geverifieerd via KvK"
      iconDataCy="readonly-kvk-verified"
    >
      <dd-value-display [field]="field()" [value]="value()" />
    </dd-verified-value>
  `,
})
export class KvkDisplayComponent extends ReadonlyDisplayBase {
  readonly verified = computed(() => isKvkVerified(this.value()));
}
